import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import MobileUpcomingSubjectPapers from './MobileUpcomingSubjectPapers';
import DesktopUpcomingSubjectPapers from './DesktopUpcomingSubjectPapers';

const UpcomingSubjectPaper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if(isMobile){
    return <MobileUpcomingSubjectPapers />
  }
  return <DesktopUpcomingSubjectPapers />
};

export default UpcomingSubjectPaper;
